module.exports = __webpack_public_path__ + "static/lsrecord-152bd258fd3e2adfd071a2a20ea2d7bc.png";